import React from 'react';
import DelegateModal from 'components/Delegate/DelegateModal';
import { setBodyOverflow } from './helpers';

type State = {
  shown: boolean;
  uuid?: string;
  onClose?: () => void;
};
type ActionType = 'show' | 'hide';
type Action = { type: ActionType; uuid?: string; onClose?: () => void };
type Dispatch = (action: Action) => void;

const DelegateDetailsDispatchContext = React.createContext<
  Dispatch | undefined
>(undefined);

function delegateDetailsReducer(state: State, action: Action) {
  switch (action.type) {
    case 'show': {
      setBodyOverflow(false);
      return {
        shown: true,
        uuid: action.uuid,
        onClose: action.onClose
      };
    }
    case 'hide': {
      // Stop the body from scrolling
      setBodyOverflow(true);
      return { shown: false, uuid: undefined };
    }
  }
}

function DelegateDetailsProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = React.useReducer(delegateDetailsReducer, {
    shown: false,
    uuid: undefined
  });
  return (
    <DelegateDetailsDispatchContext.Provider value={dispatch}>
      <DelegateModal
        isOpen={state.shown}
        onClose={() => {
          dispatch({ type: 'hide' });
          if (state.onClose) state.onClose();
        }}
        uuid={state.uuid}
      />
      {children}
    </DelegateDetailsDispatchContext.Provider>
  );
}

function useDelegateDetailsDispatch() {
  const context = React.useContext(DelegateDetailsDispatchContext);
  if (context === undefined) {
    throw new Error(
      'DelegateDetailsDispatch must be used with DelegateDetailsProvider'
    );
  }
  return context;
}

export { DelegateDetailsProvider, useDelegateDetailsDispatch };
